/* Written by Ye Liu */

import React from 'react';
import ReactDOM from 'react-dom';
import Router from '@router/router';
import * as serviceWorker from '@/serviceWorker';
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleClientId = "52578590698-8hstj018g5j8amq8buur0v2qq9hitdm5.apps.googleusercontent.com";

const App = () => (
    <Router />
);

// Render pages
ReactDOM.render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId={googleClientId}>
            <App />
        </GoogleOAuthProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// Let the app work offline and load faster
serviceWorker.register();